import { z } from "zod";
import { OPPORTUNITY_SORTS, OPPORTUNITY_VIEWS, type OpportunityFilters } from "@/api/queries/opportunities";
import { OPPORTUNITY_SOURCES, OPPORTUNITY_STAGES } from "@/api/types";

const optNum = z.coerce.number().int().nonnegative().optional().catch(undefined);
const optDate = z
  .string()
  .regex(/^\d{4}-\d{2}-\d{2}$/)
  .optional()
  .catch(undefined);
const optStr = z.string().trim().min(1).max(100).optional().catch(undefined);

/** /opportunities?… — every filter, sort and view lives in the URL so views are shareable. */
export const opportunitySearchSchema = z.object({
  view: z.enum(OPPORTUNITY_VIEWS).optional().catch(undefined),
  /** Also show lost and closed leads (off: active ones only). */
  closed: z.boolean().optional().catch(undefined),
  store: optStr,
  buyer: optStr,
  source: z.array(z.enum(OPPORTUNITY_SOURCES)).optional().catch(undefined),
  stage: z.array(z.enum(OPPORTUNITY_STAGES)).optional().catch(undefined),
  scoreMin: optNum,
  make: optStr,
  model: optStr,
  yearMin: optNum,
  yearMax: optNum,
  mileageMax: optNum,
  createdFrom: optDate,
  createdTo: optDate,
  updatedFrom: optDate,
  updatedTo: optDate,
  q: optStr,
  sort: z.enum(OPPORTUNITY_SORTS).optional().catch(undefined),
  order: z.enum(["asc", "desc"]).optional().catch(undefined),
}) satisfies z.ZodType<OpportunityFilters>;

export type OpportunitySearch = z.infer<typeof opportunitySearchSchema>;

export const VIEW_LABEL: Record<(typeof OPPORTUNITY_VIEWS)[number], string> = {
  all: "All",
  needs_attention: "Needs attention",
  rogue_working: "Rogue working",
  hot_seller: "Hot sellers",
  offer_gap_lt_1k: "Offer gap < $1k",
  aged_7d: "Aged 7+ days",
  approval_required: "Approval required",
};
